import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionEight = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });


  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });




  const features = [
    {
      headline: "Post purchase journey",
    },
    {
      headline: "Pre purchase journey",
    },
    {
      headline: "Click-to-Whatsapp ads",
    },
    {
      headline: "One-stop support desk",
    },
    {
      headline: "Sale promotions",
    },
    {
      headline: "Campaign automation",
    },
    {
      headline: "Whatsapp catalog",
    },
    {
      headline: "Abandoned cart messaging",
    },
    {
      headline: "Funnel retargeting",
    },
  ];


  return (
    <div className="section-eight-Ind">
      <div >
        <div className="testimonial-content-Ind">
          <div className="testimonial-text-Ind">One solution for all your growth needs</div>
          <p className="mid-text3-Ind">Accelerate every stage of your growth funnel with <br /> a unified, end-to-end solution.</p>
        </div>

        <div className="flex  gap-3" style={{ margin: isMobile ? "0 0" : "0 185px", flexDirection: isMobile ? "column" : "row" }}>
          <div className="sec8a" style={{ height: isMobile ? "auto" : 'auto', width: "100%" }}>
            <div style={{display:"flex",flexDirection:"column"}}>
              <h1>Marketing, Retention, and Support</h1>
              <p >Power your brand's entire lifecycle with a unified solution built to attract, engage, and support customers at every stage of their journey.</p>
              <img   style={{marginTop:"93px"}} src="/assets/images/keindia/media.png" alt="" />
            </div>
          </div>

          <div className="sec8b" >
            <div >
              {
                features.map((text, idx) => (
                  <p key={idx} className="mt-3 second">
                    <img
                      src="/assets/images/keinternational/check.png"
                      alt=""
                    />
                    <span className="mx-2">{text.headline}</span>
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
